var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagPakistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0109C0 22.0756 3.37431 27.3517 8.34781 30.0654V1.9563C3.37431 4.66999 0 9.94617 0 16.0109Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0107422C13.2282 0.0107422 10.621 0.71593 8.34784 1.95618V30.0652C10.621 31.3056 13.2282 32.0107 16 32.0107C24.8365 32.0107 32 24.8472 32 16.0107C32 7.17424 24.8365 0.0107422 16 0.0107422Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8413 18.6569C20.8171 20.1194 17.9904 19.6642 16.5279 17.64C15.0653 15.6158 15.5206 12.7892 17.5448 11.3267C18.1759 10.8707 18.8851 10.6012 19.6065 10.5075C18.2186 10.2999 16.7514 10.6127 15.5241 11.4995C13.0328 13.2996 12.4724 16.7784 14.2724 19.2698C16.0725 21.761 19.5514 22.3215 22.0428 20.5212C23.2702 19.6344 24.0278 18.3399 24.2664 16.9568C23.951 17.6122 23.4724 18.2008 22.8413 18.6569Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7546 10.4458L23.8948 11.6746L25.4158 10.9701L24.5994 12.4341L25.7396 13.6631L24.0948 13.339L23.2785 14.8031L23.0784 13.1387L21.4337 12.8147L22.9547 12.1102L22.7546 10.4458Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPakistan);
export default __webpack_public_path__ + "static/media/flag_pakistan.0a9c825bf481366804a4fa96f9e6c63d.svg";
export { ForwardRef as ReactComponent };